import { UPDATE_PREFERENCE } from '../actions/action-types';
import { INCH } from '../lib/unitConversions';

const initialState = {
  lengthUnit: INCH.name
};

const preference = (state = initialState, action) => {
  switch(action.type){
    case UPDATE_PREFERENCE:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

export default preference;

export function getLengthUnit(state) {
  return state.lengthUnit;
}


// WEBPACK FOOTER //
// ./src/reducers/preference.js